var mapInfo = {
	isOpened:false,
	isMapRunning: false,
	initialized:false,
	cfg:null,
	route:null,
	isDesktop:false,
	splitView:false,
	miniView: false,
	showStreetViewOnStart:false,
	here:null,
	lastMark:null,
	enlargeNode: null,
	radar: null,
	disabled: false,
	markIds: {},
	lastActive: null,
	geoloc: false,

	load: function(j) {
		//Log.debug(j);
		mapInfo.cfg = j;
		SpeechManager.prepareTip("PLAYER.MAPBAR.HIDE", "TIPS");
		SpeechManager.prepareTip("PLAYER.MAPBAR.MINIMIZE", "TIPS");
		SpeechManager.prepareTip("MAP_ZOOM", "TIPS");
		SpeechManager.prepareTip("PLAYER.ROUTE", "TIPS");
		
		Tab.setGroup("map", "+");
		Tab.add("map", Tab.simpleTabInput($("#front_search"), 2, "focused", true), {});
		Tab.add("map", Tab.simpleTab($("#searchbar").find(".button"), 5), {});
		Tab.add("map", Tab.simpleTab(function() {return $("#map_enlarge");}, 10, "focused", function() {return $("#map_enlarge img");}), {});
		Tab.add("map", Tab.simpleTab(function() {return $("#map_close");}, 15, "focused", function() {return $("#map_close img");}), {});

		Tab.add("map", Tab.simpleTab(function() {return $("#mapbar .back");}, 20), {});

		Tab.groups["map"].disable();
	},
	
	back: function() {
		mapInfo.hideMenu();
	},
	
	toggleMenu: function() {
		if (isOpened) mapInfo.hideMenuReal();
		else mapInfo.showMenu();
	},
	
	fetchLocation: function(location) {
		//alert("Pobrana lokalizacja: " + location.coords.latitude + "," + location.coords.longitude);
		if (confirm("Czy otworzyć stronę z wyznaczoną trasą ?")) {
			window.open("http://maps.google.com/maps", "_blank");
//			window.open("http://maps.google.com/maps?saddr=" + location.coords.latitude + "," + location.coords.longitude + "&daddr=" + mapInfo.route.lat + "," + mapInfo.route.lon + "&ll=", "_blank");
		}
	},
	
	fetchLocationFailed: function(err) {
		alert("Nie można było pobrać lokalizacji urządzenia, aby skorzystać z tej funkcji musisz umożliwić Twojej przeglądarce pobranie informacji o Twojej lokalizacji.");
	},
	
	openRouteMap: function(gx, gy) {
		//try {
			//window.open("http://maps.google.com/maps", "_blank");
			window.open("http://maps.google.com/maps?saddr=&daddr=" + gx + "," + gy + "&ll=", "_blank");
			
			return;
			
			mapInfo.route = {"lat":gx, "lon":gy};
			if (!navigator || !navigator.geolocation) {
				alert("Twoje urządzenie nie obsługuje geolokacji.");
			} else {
				navigator.geolocation.getCurrentPosition(mapInfo.fetchLocation, mapInfo.fetchLocationFailed);
			}
			/*
			navigator.geolocation.getCurrentPosition(function(location) {
				alert(location);
//				window.open("http://maps.google.com/maps?saddr=" + location.coords.latitude + "," + location.coords.longtitude + "&daddr=" + gx + "," + gy + "&ll=", "_blank");
//				window.open("http://maps.google.com/maps?saddr=&daddr=" + gx + "," + gy + "&ll=", "_blank");
			});
			*/
		/*
		} catch(Exception e) {
			window.open("http://maps.google.com/maps?saddr=Current+Location&daddr=" + gx + "," + gy + "&ll=", "_blank");
		}*/
	},
	
	initMap: function() {
		//console.trace();

		$("#mapbar .coords").html("");
		$("#mapcontent").html("");
		ssi("Plan","load",{"place":player.ident},function(resp) {
			if (resp.data.plan_id != undefined) {
				Plan.start(resp.data);
			} else {
				Plan.release();
				mapInfo.loadGMap();
			}
		});

		if (!mapInfo.initialized) {
			AppEvent.on(player, "placeReady", function(pe) { mapInfo.placeReady(); });
			AppEvent.on(player, "PLACE.LOADED", function(pe) { mapInfo.placeLoaded(); });
			mapInfo.initialized = true;

			$("#front_search").on("keydown", mapInfo.detectEnter);
			$("#front_search").prop("placeholder", TPL.lng("tips.search", "Szukaj ..."));
			$("#front_search").prop("title", TPL.lng("tips.entersearchtext", "Wpisz szukany tekst"));
		}

	},

	detectEnter: function(e) {
		var code = e.which;
			if(code == 13 || code == 8) {
				e.preventDefault();
				e.stopPropagation();
			}
			if(code == 32 || code == 13 || code == 188 || code == 186) {
    			mapInfo.goSearch();
			};
	},

	findMe: function() {
		mapInfo.geoloc = !mapInfo.geoloc;

		if (mapInfo.geoloc) {
			$("#findme").html("<i class='fas fa-spinner fa-spin'></i>");
			$("#findme").addClass("on");
		} else {
			if (mapInfo.me != undefined) {
				mapInfo.me.setVisible(false);
			}
			$("#findme").html("<i class='fas fa-street-view'></i>");
			$("#findme").removeClass("on");
          	mapInfo.map.panTo(mapInfo.here.getPosition());
          	return;
		}

		if (navigator.geolocation) {
		    navigator.geolocation.getCurrentPosition(mapInfo.geoLocate, mapInfo.geoError);
		} else {
			$("#findme").html("<i class='fas fa-street-view'></i>");
		    alert("Twoja przeglądarka nie była w stanie pobrać Twojej lokalizacji.");
		}		
	},

	geoError: function(error) {
		mapInfo.geoloc = false;
		$("#findme").html("<i class='fas fa-street-view'></i>");
		$("#findme").removeClass("on");
		  switch(error.code) {
		    case error.PERMISSION_DENIED:
		      alert("Użytkownik nie zezwolił na pobranie informacji o geolokacji.");
		      break;
		    case error.POSITION_UNAVAILABLE:
		      alert("Informacja o lokalizacji jest niedostępna.");
		      break;
		    case error.TIMEOUT:
		      alert("Przekroczono czas pobierania informacji o lokalizacj.");
		      break;
		    case error.UNKNOWN_ERROR:
		      alert("Wystąpił nieznany błąd przy pobieraniu informacji o aktualizacji.");
		      break;
		  }
	},

	geoLocate: function(position) {
		var myLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

		if (mapInfo.me == undefined) {
			//var image = 'assets/marker.png';
			var imagehere = 'assets/__marker-2.png';

			var ic = {
				url: imagehere,
				scaledSize: new google.maps.Size(41, 46),
				origin: new google.maps.Point(0,0),
				//anchor: new google.maps.Point(20, 25)
			};

			mapInfo.me = new google.maps.Marker({
				position: myLatLng,
				map: mapInfo.map,
				icon: ic,
				optimized: false,
	      		zIndex:99999999
			});
		}

		mapInfo.me.setVisible(true);

		$("#findme").html("<i class='fas fa-street-view'></i>");

		mapInfo.map.setCenter(myLatLng);

		mapInfo.me.setAnimation(google.maps.Animation.BOUNCE);

		//console.log(position);
	},

	goSearch: function() {
		Search.openAndFind($("#front_search").val());
	},

	placeLoaded: function() {
		
		setTimeout(function() {

//			if (mapInfo.miniView == false && isOpened !== true) mapInfo.toggleMiniMap();

			if (mapInfo.miniView) {
				if (player.current.place_type == "panorama" && !mapInfo.disabled) {
					$("#mapinfo").removeClass("hidden");
				} else if (mapInfo.clicked == undefined) {
					mapInfo.splitView = false;

					//$("#player").hide();
					if (mapInfo.map != undefined) mapInfo.map.set('fullscreenControl', false);
					$("#mapinfo").addClass("mini");
					$("#mapinfo").addClass("hidden");
					$("#player").css("left", "0%");
					$("#player").css("width", "100%");
					$("#hotspots").css("left", "0%");
					$("#info").css("left", "0%");
					$("#menu_container").css("left", "0%");

					$("#mapinfo").removeClass("small");

					mapInfo.infowindow.close();
				}
			}		
		}, 5000);
	},

	placeReady: function() {
		var drs = player.dir.toString().split(",");

		mapInfo.me = undefined;

		if (player.current.properties.map_state != undefined && player.current.properties.map_state == 'open' && mapInfo.miniView !== true) {
			if (mapInfo.clicked == true) mapInfo.clicked = false;
			this.toggleMiniMap();
		} else if (mapInfo.clicked != true && mapInfo.miniView === true && player.current.properties.map_state != 'open') {
			this.toggleMiniMap();
		}

		$("#mapbar .coords").html("<a href='javascript:void(null);' id='findme' on" + Events.pointer.up + "='mapInfo.findMe();' title='Znajdź moją lokalizację'><i class='fas fa-spinner fa-spin'></i></a> <a href='javascript:void(null);' on" + Events.pointer.up + "='mapInfo.openRouteMap(" + player.current.gps_x + ", " + player.current.gps_y + ")' class='rbutton speaks' title='Wyznacz trasę' data-speak='PLAYER.ROUTE' data-speakgroup='TIPS'><i class='fas fa-route'></i></a> &nbsp; " + player.current.gps_x + "N, " + player.current.gps_y + "E");

		if (mapInfo.isMapRunning) {
			var cm = mapInfo.markIds[player.ident];
			if (cm != undefined && cm != null) {
				cm.setAnimation(google.maps.Animation.BOUNCE);

				mapInfo.here = cm;
				mapInfo.hereMarker.setVisible(false);
			} else if (mapInfo.hereMarker != undefined) {
				mapInfo.here = mapInfo.hereMarker;
				mapInfo.here.setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});
				mapInfo.hereMarker.setVisible(true);
				mapInfo.hereMarker.setAnimation(google.maps.Animation.BOUNCE);
			}

			if (mapInfo.lastActive != null) {
				var cm = mapInfo.markIds[mapInfo.lastActive];
				if (cm != null && cm != undefined) cm.setAnimation(null);
			}
			mapInfo.lastActive = player.ident;

			if (drs[0].substr(0, 1) == "@" && !mapInfo.splitView) {
				mapInfo.showStreetViewOnStart = true;
				mapInfo.toggleMenuDesktop();
				//mapInfo.toggleSplitView();

				//if (mapInfo.here != null) mapInfo.here.setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});
				if (mapInfo.radar != null) mapInfo.radar.setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});

				mapInfo.miniView = true;

			} else if (mapInfo.splitView) {
				//console.log(player.current.gps_x + " : " + player.current.gps_y);

				//mapInfo.here.setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});
				mapInfo.radar.setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});

				mapInfo.map.getStreetView().setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});
				mapInfo.map.getStreetView().setPov({heading: player.lastHeading, pitch: 0});
	          	mapInfo.map.panTo(mapInfo.here.getPosition());

			} else if (mapInfo.miniView) {

				if (player.current.place_type == "panorama") {
					$("#mapinfo").removeClass("hidden");
				} else {
					$("#mapinfo").addClass("hidden");
				}

				//mapInfo.here.setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});
				mapInfo.radar.setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});
				//mapInfo.map.getStreetView().setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});
				//mapInfo.map.getStreetView().setPov({heading: player.lastHeading, pitch: 0});
	          	mapInfo.map.panTo(mapInfo.here.getPosition());

			}
		}
	},
	
	loadGMap: function() {		
		mapInfo.isMapRunning = true;

		console.trace();

		var mapOptions = {
			zoom: 18,
			center: new google.maps.LatLng(mapInfo.cfg.gps_x, mapInfo.cfg.gps_y),
			//rotateControl: true,
			fullscreenControl: true,
			mapTypeId: google.maps.MapTypeId.HYBRID //ROADMAP
		};

		map = new google.maps.Map(document.getElementById('mapcontent'),mapOptions);

		mapInfo.geoloc = false;
		mapInfo.me = undefined;
		
		var image = 'assets/marker.png';
		var imagehere = 'assets/__marker-2.png';
		var myLatLng = new google.maps.LatLng(mapInfo.cfg.gps_x, mapInfo.cfg.gps_y);

		var ic = {
			url: image, //here,
			scaledSize: new google.maps.Size(21, 24),
			origin: new google.maps.Point(0,0),
			//anchor: new google.maps.Point(20, 25)
		};
		
		// <a href='javascript:void(null);' on" + Events.pointer.up + "='mapInfo.toggleSplitView();' style='color:#ffffff;float:right;display:inline-block;padding-right:10px;'>Widok dzielony</a>
		//$("#mapbar .coords").html("<a href='javascript:void(null);' on" + Events.pointer.up + "='mapInfo.findMe();' style='color:#ffffff;padding-left: 15px; padding-right: 15px;'><i class='fas fa-street-view'></i></a> <a href='javascript:void(null);' on" + Events.pointer.up + "='mapInfo.openRouteMap(" + mapInfo.cfg.gps_x + ", " + mapInfo.cfg.gps_y + ")' style='color:#ffffff;padding-left: 15px; padding-right: 15px;'><i class='fas fa-route'></i></a>  " + mapInfo.cfg.gps_x + "N, " + mapInfo.cfg.gps_y + "E");
		$("#mapbar .coords").html("<a href='javascript:void(null);' on" + Events.pointer.up + "='mapInfo.findMe();' id='findme' title='Zanjdź moją lokalizację'><i class='fas fa-spinner fa-spin'></i></a> <a href='javascript:void(null);' on" + Events.pointer.up + "='mapInfo.openRouteMap(" + player.current.gps_x + ", " + player.current.gps_y + ")' class='rbutton speaks' title='Wyznacz trasę'  data-speak='PLAYER.ROUTE' data-speakgroup='TIPS'><i class='fas fa-route'></i></a> &nbsp; " + player.current.gps_x + "N, " + player.current.gps_y + "E");

//		SpeechManager.enableSpeech("#mapbar .coords", ".speaks", 1, "TOPMENU");

		$("#mapinfo .back").on(Events.pointer.up, mapInfo.hideMenuReal);
		$("#mapinfo .back").on("keydown", function(evt) { if (evt.key == 'Enter') mapInfo.hideMenuReal();});
		
		
		var hereMarker = new google.maps.Marker({
			position: myLatLng,
			map: map,
			icon: ic,
			optimized: false,
      		zIndex:99999999
		});
		hereMarker.setAnimation(google.maps.Animation.BOUNCE);

		mapInfo.here = hereMarker;
		mapInfo.hereMarker = hereMarker;
		mapInfo.map = map;
		mapInfo.radar = new RadarMarker(myLatLng, map, {});

		mapInfo.isStreetView = false;

		google.maps.event.addListener(map.getStreetView(),'visible_changed',function() {
           mapInfo.isStreetView = this.getVisible();
        });

		mapInfo.infowindow = new google.maps.InfoWindow({
		  maxWidth: 350,
          content: ""
        });

		var m;

		setTimeout(function() {

			$.getJSON("markers.php?range=20000&cid=" + mapInfo.cfg.folder.city_id, function(response) {
				mapInfo.markers = response.markers;

				for(var n in response.markers) {
					var ll = response.markers[n];

					//if (ll.id == player.ident) continue;

					myLatLng = new google.maps.LatLng(ll.lat, ll.lng);
					//var ic = "assets/marker.png";

					var ico = "";

					switch (ll.icon) {
						case -10:
							ico = "assets/marker-green.png";
						break;

						case -3:
							ico = "assets/marker-blue.png";
						break;

						case -100:
							continue;
						break;

						default:
							ico = "assets/marker.png";
						break;
					}

					var ic = {
						url: ico,
	    				scaledSize: new google.maps.Size(17, 22),
	    				origin: new google.maps.Point(0,0),
	    				anchor: new google.maps.Point(8, 18)					
					};

					if (ll.iconfile != null && ll.iconfile != "") ic = "../gicons/" + ll.iconfile;

					//console.log(ic);

					m = new google.maps.Marker({
						position: myLatLng,
						map: map,
						icon: ic,
						no: n
					});

					if (mapInfo.markers[n].id == player.ident) {
						m.setAnimation(google.maps.Animation.BOUNCE);
						mapInfo.lastActive = mapInfo.markers[n].id;
						mapInfo.hereMarker.setVisible(false);
					}

					mapInfo.markIds[mapInfo.markers[n].id] = m;

					google.maps.event.addListener(m, 'mouseover', function() {
					  	var mark = mapInfo.markers[this.no];
						window.setStatus("ID: " + mark.id);
					});

					google.maps.event.addListener(m, 'mouseout', function() {
						window.setStatus("");
					});

					google.maps.event.addListener(m, 'mouseup', function() {
					  var mark = mapInfo.markers[this.no];
					  mapInfo.lastMark = this;
					  console.log(mark);
					  //mapInfo.infowindow.setContentHTML(mark.info + "<img src='../" + mark.preview.url + "'><hr size='1'><a href=''>Przejdź do punktu</a>");

					  var mark2 = mark;

					  var dir = "0";

					  if (mark.preview != undefined) {
					  	dir = mark.preview.rx + "," + mark.preview.ry;
					  }

					  if (mapInfo.miniView && !mapInfo.splitView) {
					  		var pov = mapInfo.map.getStreetView().getPov();
					 		mapInfo.go(mark.id, dir);
					 		return;
					  }

	//				  mapInfo.infowindow.setContent("<div style='text-align:center;color:#343434;'><b>" + mark.info + "</b><br><br><img src='../" + mark.preview.url + "' width='340px' on" + Events.pointer.up + "='mapInfo.go(" + mark.id + ", 0)'><a href='javascript:void(null);' on" + Events.pointer.up + "='mapInfo.go(" + mark.id + ", 0)' style='display:block;color:#ffffff;background-color:#00aa44;margin-top:10px;padding:6px;text-align:center;'>Przejdź do punktu</a></div>");
					  //var mark = mapInfo.markers[this.no];
					  //console.log(mark);

					  if (mark2.preview.url != "") {
					  	if (!player.offline) mapInfo.infowindow.setContent("<div style='text-align:center;color:#343434;max-width: 200px;'><b>" + mark.info + "</b><br><br><img src='../" + mark2.preview.url + "' style='cursor:pointer;' width='200px' on" + Events.pointer.up + "='mapInfo.go(" + mark.id + ", \"" + dir + "\")'></div>");
					    //else mapInfo.infowindow.setContent("<div style='text-align:center;color:#343434;max-width: 200px;'><b>" + mark.info + "</b><br><br>FOTO</div>");
					    else mapInfo.infowindow.setContent("<div style='text-align:center;color:#343434;max-width: 200px;'><b>" + mark.info + "</b><br><br><img src='" + mark2.preview.url + "' style='cursor:pointer;' width='200px' on" + Events.pointer.up + "='mapInfo.go(" + mark.id + ", 0)'></div>");
					  } else {
					  	mapInfo.infowindow.setContent("<div style='text-align:center;color:#343434;max-width: 200px;'><a href='javascript:void(null);' on" + Events.pointer.up + "='mapInfo.go(" + mark.id + ", \"" + dir + "\")'><b>" + mark.info + "</b> <div style='text-align:center;padding: 15px;color: #000000'><i class='fa fa-camera' style='font-size:40px;opacity:0.5'></i></div></a></div>");
					  }
			          
			          if (!mapInfo.isStreetView) {
			          	mapInfo.infowindow.open(map, this);
			          	mapInfo.map.panTo(this.getPosition());
			      	  } else {
			      	  	var pov = mapInfo.map.getStreetView().getPov();
			      	  	mapInfo.go(mark.id, "@" + pov.heading);
			      	  	mapInfo.map.getStreetView().setPosition(this.getPosition());
			      	  	/*
			      	  	console.log("Street view");
			      	  	console.log(mapInfo.map.getStreetView());
			      	  	var panorama = mapInfo.map.getStreetView();
			          	mapInfo.infowindow.open(panorama, this);
			          	*/
			      	  }
					  //console.log("info");
			        });				
				}

				if (mapInfo.splitView && mapInfo.showStreetViewOnStart) {
					
					mapInfo.map.getStreetView().setPosition({lat: parseFloat(player.current.gps_x), lng: parseFloat(player.current.gps_y)});
					mapInfo.map.getStreetView().setPov({heading: player.lastHeading, pitch: 0});
					mapInfo.map.streetView.setVisible(true);

					mapInfo.showStreetViewOnStart = false;
				}

				$("#findme").html("<i class='fas fa-street-view'></i>");

			});
		}, 600);
	
		/*
		google.maps.event.addListener(hereMarker, 'mousedown', function() {
			if (mapInfo.splitView) {
				mapInfo.map.getStreetView().setPosition(this.getPosition());
			} else {
				//mapInfo.hideMenuReal();
			}
		  });
		*/
	},
	
	go: function(id, dir) {
		//var id = mark.id;
		//console.log(mapInfo.lastMark);
		//mapInfo.here.setPosition(mapInfo.lastMark.getPosition());
		mapInfo.radar.setPosition(mapInfo.lastMark.getPosition());
		mapInfo.hideMenu();
		player.go(id, dir);
	},

	showWindow: function() {

		if (!player.internet) {
			alert("Musisz być połączony z internetem aby wyświetlić mapy.");
			return;
		}

		isOpened = true;
		$("#player").hide();
		player.currentView.pause();

		//player.addToHistory({},"Map Info","#map");
		//player.setHistoryManager(this);
		$("#mapinfo").removeClass("hidden");
		$("#menubutton").hide();
		//$("#infomenu").show();
	},

	showMenu: function() {
		mapInfo.showWindow();
		
		mapInfo.initMap();
		//if (event != undefined) event.preventDefault();
	},

	clickToggleMiniMap: function() {
		mapInfo.clicked = true;
		this.toggleMiniMap();
	},

	toggleMiniMap: function() {
		if (mapInfo.showStreetViewOnStart) {
			return;
		}

		if (mapInfo.splitView) {
			return;
		}

		$("#tmapbtn").toggleClass("active");

		if (mapInfo.miniView) {
			Tab.groups["map"].disable();

			$("#mapinfo").addClass("hidden");
			$("#mapinfo").removeClass("mini");
			mapInfo.miniView = false;
			mapInfo.isMapRunning = false;
			return;
		}

		if (!player.internet || $(window).width() < 1024) {
			return;
		}

		Tab.groups["map"].enable();

		$("#mapinfo").removeClass("hidden");

		SpeechManager.enableSpeech("#mapinfo", ".speaks", 1, "TOPMENU");


		//$("#menubutton").hide();

		//$("#hmenu").hide();
		
		//mapInfo.initMap();

		$("#mapbar .coords").html("");
		$("#mapcontent").html("");
		Plan.release();
		mapInfo.loadGMap();
		mapInfo.map.set('fullscreenControl', false);

		if (mapInfo.enlargeNode == null) {
			mapInfo.enlargeNode = $("#mapinfo").append("<a href='javascript:void(null);' onclick='mapInfo.toggleSplitView();' id='map_enlarge' title='" + TPL.lng("tips.enlargemap", "Powiększ mapę") + "' data-speak='MAP_ZOOM' data-speakgroup='TIPS' class='speaks'><img src='assets/enlarge.png'></a>");
			mapInfo.closeNode = $("#mapinfo").append("<a href='javascript:void(null);' onclick='mapInfo.toggleMiniMap();' id='map_close' title='" + TPL.lng("tips.closemap", "Zamknij mapę") + "' data-speak='PLAYER.MAPBAR.HIDE' data-speakgroup='TIPS' class='speaks'><img src='assets/closemap.png'></a>");
		}

		if (!mapInfo.initialized) {
			AppEvent.on(player, "placeReady", function(pe) { mapInfo.placeReady(); });
			AppEvent.on(player, "PLACE.LOADED", function(pe) { mapInfo.placeLoaded(); });
			mapInfo.initialized = true;

			$("#front_search").on("keydown", mapInfo.detectEnter);
			$("#front_search").prop("placeholder", TPL.lng("tips.search", "Szukaj ..."));
			$("#front_search").prop("title", TPL.lng("tips.entersearchtext", "Wpisz szukany tekst"));
		}


		$("#mapinfo").addClass("mini");

		player._width = $("#player").width();
		player._height = $("#player").height();
			
		setTimeout(function() {
			player.currentView.reorient();
		}, 200);


		var currCenter = mapInfo.map.getCenter();
		google.maps.event.trigger(mapInfo.map, "resize");

		mapInfo.map.setCenter(currCenter);

		mapInfo.miniView = true;
	},

	toggleMenuDesktop: function() {
		if (!player.internet) {
			alert("Musisz być połączony z internetem aby wyświetlić mapy.");
			return;
		}

		isOpened = true;
		if (!mapInfo.splitView) {
			$("#player").hide();
			player.currentView.pause();
		} else {
			$("#player").css("left", "50%");
			$("#player").css("width", "50%");
			$("#hotspots").css("left", "50%");

			$("#mapinfo").addClass("small");

			player._width = $("#player").width();
			player._height = $("#player").height();
			
			player.currentView.reorient();
		}

		//player.addToHistory({},"Map Info","#map");
		player.setHistoryManager(this);
		this.isDesktop = true;
		$("#mapinfo").removeClass("hidden");

		$("#menubutton").hide();

		$("#hmenu").hide();
		
		mapInfo.initMap();
		if (!mapInfo.splitView) mapInfo.toggleSplitView();
		//if (event != undefined) event.preventDefault();
	},
	
	hideMenuReal: function() {
		//history.back();
		if (mapInfo.splitView) mapInfo.toggleSplitView();
		mapInfo.hideMenu();
	},
	
	hideMenu: function() {
		isOpened = false;
		$("#player").show();
		player.currentView.resume();
		if (!mapInfo.splitView && !mapInfo.miniView) {
			$("#mapinfo").addClass("hidden");
			Plan.hide();
			Floors.close();
		}

		if (this.isDesktop) $("#hmenu").show();

		$("#menubutton").show();
		//$("#infomenu").hide();
		//if (event != undefined) event.preventDefault();
	},
	
	toggleSplitView: function() {
		mapInfo.splitView = !mapInfo.splitView;

		if (!mapInfo.splitView && !mapInfo.showStreetViewOnStart) {
			$("#player").hide();
			$("#mapinfo").addClass("mini");
			player.currentView.pause();
			$("#player").css("left", "0%");
			$("#player").css("width", "100%");
			$("#hotspots").css("left", "0%");
			$("#info").css("left", "0%");
			$("#menu_container").css("left", "0%");
			if (this.isDesktop) $("#hmenu").hide();

			$("#mapinfo").removeClass("small");

			if (mapInfo.map != undefined) mapInfo.map.set('fullscreenControl', false);
			mapInfo.infowindow.close();

			setTimeout(function() {
				player.currentView.reorient();
			}, 200);
			
		} else {
			$("#mapinfo").removeClass("mini");
			$("#player").show();
			$("#player").css("left", "50%");
			$("#player").css("width", "50%");
			$("#hotspots").css("left", "50%");
			$("#info").css("left", "50%");
			$("#menu_container").css("left", "50%");

			$("#mapinfo").addClass("small");
			
			player.currentView.resume();

			player._width = $("#player").width();
			player._height = $("#player").height();
			if (mapInfo.map != undefined) mapInfo.map.set('fullscreenControl', true);
			
			setTimeout(function() {
				player.currentView.reorient();
			}, 200);

			if (this.isDesktop) $("#hmenu").show();
		}

		if (mapInfo.map != undefined) {
			var currCenter = mapInfo.map.getCenter();
			google.maps.event.trigger(mapInfo.map, "resize");

			mapInfo.map.setCenter(currCenter);
		}
	}
}

function RadarMarker(latlng, map, args) {
	this.latlng = latlng;	
	this.args = args;	
	this.offset = 160;
	this.setMap(map);	
	var self = this;
	setInterval(function() {self.process();}, 10);
}

RadarMarker.prototype = new google.maps.OverlayView();

RadarMarker.prototype.process = function() {
	if (player.current.place_type == "panorama") {
		var cr = player.currentView.getRX();// + this.offset;
		cr = (360 - cr) + 90;
		try {
			cr += parseFloat(player.current.properties.north);
		} catch(e) {

		} 

		cr = 360 - cr;

		if (this.node != undefined) this.node.css("transform", "rotate(" + cr + "deg)");
		//console.log(player.currentView.rx);
	}
};

RadarMarker.prototype.draw = function() {
	
	var self = this;
	
	var div = this.div;
	
	if (player.current.properties.north == 0) return;

	if (!div) {
		
		this.node = $("<div style='transform-origin: 50% 100%'><img src='assets/radar.png' width='100%'></div>");
		div = this.div = this.node[0];
		//div = this.div = document.createElement('div');
		
		div.className = 'marker';
		
		div.style.position = 'absolute';
		div.style.cursor = 'pointer';
		div.style.width = '100px';
		div.style.height = '100px';
		
		var panes = this.getPanes();

//		panes.overlayImage.appendChild(div);
		panes.overlayLayer.appendChild(div);
	}
	
	var point = this.getProjection().fromLatLngToDivPixel(this.latlng);
	
	if (point) {
		div.style.left = (point.x - 50) + 'px';
		div.style.top = (point.y - 100) + 'px';
	}
};

RadarMarker.prototype.remove = function() {
	if (this.div) {
		this.div.parentNode.removeChild(this.div);
		this.div = null;
	}	
};

RadarMarker.prototype.getPosition = function() {
	return this.latlng;
};

RadarMarker.prototype.setPosition = function(ll) {
	var lt = new google.maps.LatLng(ll.lat, ll.lng);
	this.latlng = lt;
};

$(document).ready(function() {
	if (!mapInfo.initialized) {
		AppEvent.on(player, "placeReady", function(pe) { mapInfo.placeReady(); });
		AppEvent.on(player, "PLACE.LOADED", function(pe) { mapInfo.placeLoaded(); });
		mapInfo.initialized = true;
		
		$("#front_search").on("keyup", mapInfo.detectEnter);
		$("#front_search").prop("placeholder", TPL.lng("tips.search", "Szukaj ..."));
		$("#front_search").prop("title", TPL.lng("tips.entersearchtext", "Wpisz szukany tekst"));
	}
});